import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { setData } from "../../../Landing/input.slice.js";
import { useInputFormsHook } from "../../hooks";
import { personalFormSchema } from "./validation.js";

const usePersonalForm = (current, setCurrent) => {
  const { getPersonalFormData, setPersonalFormData } = useInputFormsHook();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    watch,
    reset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(personalFormSchema({ minAge: 18, maxAge: 65 })),
    defaultValues: {},
  });
  const [age, setAge] = useState(getPersonalFormData()?.age);
  useEffect(() => {
    reset(getPersonalFormData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);
  const dispatch = useDispatch();

  const onSubmit = data => {
    dispatch(
      setData({ ...data, dob: data.dob.split(" / ").reverse().join("-") }),
    );
    setCurrent(current + 1);
    setPersonalFormData(data, age);
  };
  const date = watch("dob");

  return {
    onSubmit,
    handleSubmit,
    register,
    errors,
    clearErrors,
    date,
    age,
    setAge,
    setValue,
  };
};

export default usePersonalForm;
